import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/winter-2023-excellence-selection/Index.vue')

const Publish = () => import('../activity/winter-2023-excellence-selection/Publish.vue')

const SchoolFullRank = () => import('../activity/winter-2023-excellence-selection/SchoolFullRank.vue')

const PublicationFullRank = () => import('../activity/winter-2023-excellence-selection/PublicationFullRank.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/winter-2023-excellence-selection',
  name: 'winter_2023_excellence_selection',
  component: Index,
  meta: {
    title: '享智慧教学 展教师风采',
  },
}

export const publishRoute: RouteConfig = {
  path: '/activity/winter-2023-excellence-selection-publish',
  name: 'winter_2023_excellence_selection_publish',
  component: Publish,
  meta: {
    title: '投稿',
  },
}

export const schoolFullRankRoute: RouteConfig = {
  path: '/activity/winter-2023-school-full-rank-list',
  name: 'winter_2023_school_full_rank_list',
  component: SchoolFullRank,
  meta: {
    title: '排行榜',
  },
}

export const publicationFullRankRoute: RouteConfig = {
  path: '/activity/winter-2023-publication-full-rank-list',
  name: 'winter_2023_publication_full_rank_list',
  component: PublicationFullRank,
  meta: {
    title: '排行榜',
  },
}

export default [indexRoute, publishRoute, schoolFullRankRoute, publicationFullRankRoute]
